
import React from "react";
import { AlertCircle } from "lucide-react";

interface ErrorAlertProps {
  message: string;
}

const ErrorAlert = ({ message }: ErrorAlertProps) => (
  <div className="bg-red-500/10 border border-red-500/20 rounded-md p-3 text-sm text-red-500 flex items-start gap-2 mt-2">
    <AlertCircle className="h-5 w-5 flex-shrink-0 pt-0.5" />
    <span>{message}</span>
  </div>
);

export default ErrorAlert;
